var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { BaseApp } from '../base-app';
import { GenesisRouterConstants, RouterConstants } from '../../../configuration/router.constants';
import { PLATFORM } from 'aurelia-pal';
import { autoinject } from 'aurelia-dependency-injection';
import { TokenClient } from '../../../services/authentication/token-client.service';
import { NotificationClientService, NotificationType } from '../../../services/basics/notification-client.service';
import { EntityTypeConfigurationHelper, EntityTypes } from '../../../models/basics/basics.models';
import * as Enumerable from 'linq';
import { DialogClientService } from '../../../services/basics/dialog-client.service';
import { Router } from 'aurelia-router';
import { QueryFilter, DataType } from '../../../models/queries/queries.models';
import { EventAggregator } from 'aurelia-event-aggregator';
import { TemplatingEngine, ViewResources } from 'aurelia-framework';
import { metadata } from 'aurelia-metadata';
import { DataGrid } from '../../components/data-grid/data-grid';
import { SignalClientService } from '../../../services/basics/signal-client.service';
import { CacheClient } from '../../../services/basics/client-caching.service';
import { NavigationClientService } from '../../../services/modules/navigation-client.service';
import { UserClaimsService } from '../../../services/authentication/user-claims.service';
import { Claims } from '../../../constants/authentication/claims';
import { LotteryPlatformClaims } from '../../../constants/modules/lotteryplatform.claims';
import { LookupClientService } from '../../../services/lookups/lookup-client.service';
import { I18N } from 'aurelia-i18n';
import { UserModel } from '../../../models/modules/lotteryplatofrm.models';
import { NotificationEntryTypeEnum } from '../../../models/notifications/notifications.models';
import { NotificationCenterEntryComposer } from '../../components/notification-center/notification-center-entry-composer';
import { Guid } from "../../../utilities/guid";
import 'material-design-icons-iconfont/dist/material-design-icons.css';
//notifications
require("../../components/notification-center/notifications/classic-notification");
require("../../components/notification-center/notifications/workflow-notification");
require('../../../styles/admin/core-admin.scss');
var Admin = /** @class */ (function (_super) {
    __extends(Admin, _super);
    function Admin(router, tokenClient, notificationClientService, entityTypeConfigurationHelper, lookupsService, dialogClient, eventAggregator, resources, templatingEngine, signalClientService, cacheClient, navigationClient, userClaimsService, i18N, notificationCenterEntryComposer) {
        var _this = this;
        var _a;
        _this = _super.call(this, router, tokenClient, dialogClient, eventAggregator, signalClientService, cacheClient, navigationClient, lookupsService) || this;
        _this.notificationClientService = notificationClientService;
        _this.entityTypeConfigurationHelper = entityTypeConfigurationHelper;
        _this.resources = resources;
        _this.templatingEngine = templatingEngine;
        _this.userClaimsService = userClaimsService;
        _this.i18N = i18N;
        _this.showDatePicker = false;
        _this.entityTypes = _this.entityTypeConfigurationHelper.getConfiguration([
            'Lotteries',
            'InstantGames',
            'Sweepstakes',
            'Brands',
            'Players',
            'TicketLines',
            'TicketLineDraws'
        ]);
        _this.previousRowItem = null;
        eventAggregator.subscribe('show-date-picker', function () {
            _this.showDatePicker = true;
        });
        eventAggregator.subscribe('hide-date-picker', function () {
            _this.showDatePicker = false;
        });
        var env = window['deployment'];
        var envMap = {
            Development: 'Dev',
            Staging: 'Stage',
            Production: ''
        };
        _this.appEnvironment = (_a = envMap[env]) !== null && _a !== void 0 ? _a : env;
        _this.appVersion = window['version'];
        notificationCenterEntryComposer.register({ type: NotificationEntryTypeEnum.WorkflowAssignment, viewModel: './notifications/workflow-notification' });
        return _this;
        //this.showSupportPage = this.userClaimsService.hasPermission(LotteryPlatformClaims.ViewSupportPage);
    }
    //public showSupportPage: boolean = false;
    Admin.prototype.showNotificationCenter = function ($event) {
        this.notificationsPanel.togglePanel($event);
    };
    Admin.prototype.activate = function () {
        return _super.prototype.activate.call(this);
    };
    Object.defineProperty(Admin.prototype, "viewTopUp", {
        get: function () {
            return this.tokenClient.isSuperAdmin() || this.userClaimsService.hasPermission(LotteryPlatformClaims.ViewTopUp);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Admin.prototype, "viewInsuranceAccount", {
        get: function () {
            return this.tokenClient.isSuperAdmin() || this.userClaimsService.hasPermission(LotteryPlatformClaims.ViewInsuranceAccount);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Admin.prototype, "menu", {
        get: function () {
            var _this = this;
            var routes = this.getRoutes();
            var menuItems = Enumerable.from(routes)
                .where(function (x) { return x.settings && x.settings.showInMenu && !x.settings.groupName; })
                .select(function (x) { return _this.toMenuTab(x); }).toArray();
            var groupedMenuItems = Enumerable.from(routes)
                .where(function (x) { return x.settings && x.settings.showInMenu && x.settings.groupName; })
                .groupBy(function (x) { return x.settings.groupName; }).toArray();
            return menuItems.concat(Enumerable.from(groupedMenuItems).select(function (x) {
                var e_1, _a;
                var routes = x.toArray();
                try {
                    for (var routes_1 = __values(routes), routes_1_1 = routes_1.next(); !routes_1_1.done; routes_1_1 = routes_1.next()) {
                        var route = routes_1_1.value;
                        if (!('isVisible' in route)) {
                            route.isVisible = true;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (routes_1_1 && !routes_1_1.done && (_a = routes_1.return)) _a.call(routes_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return {
                    key: routes[0].settings.groupName,
                    title: routes[0].settings.groupName,
                    routes: routes
                };
            }).toArray());
        },
        enumerable: false,
        configurable: true
    });
    Admin.prototype.onDocumentClick = function () {
        this.settingsDropdownOpen = false;
    };
    Admin.prototype.searchItemSelected = function (e) {
        var detail = e.detail;
        if (detail && detail.selectedEntityUri && detail.selectedEntity) {
            var route = Enumerable.from(this.router.routes).firstOrDefault(function (x) { return x.editEntityUri == e.detail.selectedEntityUri; });
            this.router.navigateToRoute(route.name, {
                id: e.detail.selectedEntity.id
            });
        }
    };
    Admin.prototype.onReconnected = function () {
    };
    Admin.prototype.getRoutes = function () {
        var _this = this;
        var self = this;
        var manageGroupName = 'Manage';
        var gamesGroupName = 'Games';
        var lotteriesGroupName = 'Lotteries';
        var brandsGroupName = this.tokenClient.user.enableAgent ? 'Super Agents' : 'Brands';
        var winningGroupName = 'Winning';
        var reportingGroupName = 'Reporting';
        var BillingGroupName = 'Billing';
        var supportGroupName = 'Support';
        return [
            {
                route: ['', 'dashboard'],
                name: GenesisRouterConstants.RouteNames.Dashboard,
                moduleId: PLATFORM.moduleName('../../pages/dashboard/dashboard'),
                settings: { showInMenu: this.userClaimsService.hasPermission(Claims.Dashboard) },
                claimsRequired: [Claims.Dashboard],
                nav: true,
                auth: true,
                title: 'Dashboard'
            },
            // LOTTERIES
            {
                nav: true,
                route: ['lotteries'],
                auth: true,
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListLotteries),
                    groupName: lotteriesGroupName
                },
                title: 'List Lotteries',
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                entity: this.tokenClient.isBrandAdmin() ? 'BrandLotteries' : 'Lotteries',
                editRoute: RouterConstants.RouteNames.ManageLottery,
                claimsToAdd: [LotteryPlatformClaims.EditLotteries],
                claimsRequired: [LotteryPlatformClaims.ListLotteries],
                name: RouterConstants.RouteNames.ListLotteries,
                onRowSelected: function (x) {
                    if (_this.tokenClient.isBrandAdmin())
                        _this.router.navigateToRoute(RouterConstants.RouteNames.ManageLottery, {
                            id: x.lotteryId,
                            brandId: x.brandId,
                            brandName: x.brand,
                            brandLanguages: x.brandLanguages ? x.brandLanguages.split(",").map(function (x) { return Number(x); }) : [],
                            brandTemplateInternalName: x.brandTemplateInternalName,
                            brandThemeInternalName: x.brandThemeInternalName
                        });
                    else
                        _this.router.navigateToRoute(RouterConstants.RouteNames.ManageLottery, { id: x.lotteryId });
                }
            },
            {
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.EditLotteries)
                        && this.userClaimsService.hasPermission(LotteryPlatformClaims.CreateLottery),
                    groupName: lotteriesGroupName
                },
                route: ['create-lottery', 'lottery/:id'],
                name: RouterConstants.RouteNames.ManageLottery,
                moduleId: PLATFORM.moduleName('./lottery/lottery'),
                title: 'Create Lottery',
                auth: true,
                entityTypeRoute: EntityTypes.Lottery,
                claimsRequired: [],
                editEntityUri: this.tokenClient.isBrandAdmin() ? 'BrandLotteries' : 'Lotteries',
            },
            // INSTANT GAMES
            {
                nav: true,
                route: ['instant-games'],
                auth: true,
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListInstantGames),
                    groupName: gamesGroupName
                },
                title: 'List Instant Games',
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                entity: this.tokenClient.isBrandAdmin() ? 'BrandInstantGames' : 'InstantGames',
                editRoute: RouterConstants.RouteNames.ManageInstantGame,
                claimsToAdd: [LotteryPlatformClaims.EditInstantGame],
                claimsRequired: [LotteryPlatformClaims.ListInstantGames],
                name: RouterConstants.RouteNames.ListInstantGames,
                onRowSelected: function (x) {
                    var options = {};
                    if (_this.tokenClient.isBrandAdmin())
                        options = {
                            id: x.instantGameId,
                            brandId: x.brandId,
                            brandName: x.brand,
                            brandLanguages: x.brandLanguages ? x.brandLanguages.split(",").map(function (x) { return Number(x); }) : [],
                            brandTemplateInternalName: x.brandTemplateInternalName,
                            brandThemeInternalName: x.brandThemeInternalName,
                            isOpenedFromBrandAdmin: true
                        };
                    else
                        options = { id: x.instantGameId, isOpenedFromLotteryAdmin: true };
                    var route = Enumerable.from(_this.router.routes).firstOrDefault(function (x) { return x.name == RouterConstants.RouteNames.ManageInstantGame; });
                    if (!route.settings)
                        route.settings = {};
                    route.settings.options = options;
                    _this.router.navigateToRoute(RouterConstants.RouteNames.ManageInstantGame, { id: options.id });
                }
            },
            {
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.EditInstantGame)
                        && this.userClaimsService.hasPermission(LotteryPlatformClaims.CreateInstantGame),
                    groupName: gamesGroupName
                },
                route: ['create-instant-game', 'instant-game/:id'],
                name: RouterConstants.RouteNames.ManageInstantGame,
                moduleId: PLATFORM.moduleName('./instant-game/instant-game'),
                title: 'Create Instant Game',
                auth: true,
                entityTypeRoute: EntityTypes.InstantGame,
                claimsRequired: [],
                editEntityUri: this.tokenClient.isBrandAdmin() ? 'BrandInstantGames' : 'InstantGames',
            },
            // Sweepstakes
            {
                nav: true,
                route: ['sweepstakes'],
                auth: true,
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListSweepstakes),
                    groupName: gamesGroupName
                },
                title: 'List Sweepstakes',
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                entity: this.tokenClient.isBrandAdmin() ? 'BrandSweepstakes' : 'Sweepstakes',
                createNewRoute: RouterConstants.RouteNames.ManageSweepstakes,
                editRoute: RouterConstants.RouteNames.ManageSweepstakes,
                claimsToAdd: [LotteryPlatformClaims.EditSweepstake],
                claimsRequired: [LotteryPlatformClaims.ListSweepstakes],
                name: RouterConstants.RouteNames.ListSweepstakes,
                onRowSelected: function (x) {
                    var options = {};
                    if (_this.tokenClient.isBrandAdmin())
                        options = {
                            id: x.sweepstakeId,
                            brandId: x.brandId,
                            brandName: x.brand,
                            brandLanguages: x.brandLanguages ? x.brandLanguages.split(",").map(function (x) { return Number(x); }) : [],
                            brandTemplateInternalName: x.brandTemplateInternalName,
                            brandThemeInternalName: x.brandThemeInternalName,
                            isOpenedFromBrandAdmin: true
                        };
                    else
                        options = { id: x.sweepstakeId, isOpenedFromLotteryAdmin: true };
                    var route = Enumerable.from(_this.router.routes).firstOrDefault(function (x) { return x.name == RouterConstants.RouteNames.ManageSweepstakes; });
                    if (!route.settings)
                        route.settings = {};
                    route.settings.options = options;
                    _this.router.navigateToRoute(RouterConstants.RouteNames.ManageSweepstakes, { id: options.id });
                }
            },
            {
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.EditSweepstake)
                        && this.userClaimsService.hasPermission(LotteryPlatformClaims.CreateSweepstake),
                    groupName: gamesGroupName
                },
                route: ['create-sweepstakes', 'sweepstakes/:id'],
                name: RouterConstants.RouteNames.ManageSweepstakes,
                moduleId: PLATFORM.moduleName('./sweepstake/sweepstake'),
                title: 'Create Sweepstake',
                auth: true,
                entityTypeRoute: EntityTypes.Sweepstake,
                claimsRequired: [],
                editEntityUri: this.tokenClient.isBrandAdmin() ? 'BrandSweepstakes' : 'Sweepstakes',
            },
            {
                settings: {
                    showInMenu: false,
                },
                route: ['create-bundle', 'bundle/:id'],
                name: RouterConstants.RouteNames.ManageBundle,
                moduleId: PLATFORM.moduleName('./bundle/bundle'),
                title: 'Create Bundle',
                auth: true,
                entityTypeRoute: EntityTypes.Bundle,
                claimsRequired: [],
                editEntityUri: 'Bundles',
            }, {
                settings: {
                    showInMenu: false,
                },
                route: ['create-syndicate', 'syndicate/:id'],
                name: RouterConstants.RouteNames.ManageSyndicate,
                moduleId: PLATFORM.moduleName('./syndicate/syndicate'),
                title: 'Create Syndicate',
                auth: true,
                entityTypeRoute: EntityTypes.Syndicate,
                claimsRequired: [],
                editEntityUri: 'Syndicates',
            },
            // BRANDS op
            {
                nav: true,
                route: ['brands'],
                auth: true,
                settings: {
                    title: this.tokenClient.user.enableAgent ? 'Super Agents' : 'Brands',
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListBrands),
                    groupName: brandsGroupName
                },
                title: this.tokenClient.user.enableAgent ? 'List Super Agents' : 'List Brands',
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                entity: 'Brands',
                editRoute: RouterConstants.RouteNames.ManageBrand,
                claimsRequired: [LotteryPlatformClaims.ListBrands],
                name: RouterConstants.RouteNames.ListBrands,
                onColumnPushed: this.enableAgentColumnNameReplacement.bind(this)
            },
            {
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.CreateBrand),
                    groupName: brandsGroupName
                },
                route: ['create-brand', 'brand/:id'],
                name: RouterConstants.RouteNames.ManageBrand,
                moduleId: PLATFORM.moduleName('./brand/brand'),
                title: this.tokenClient.user.enableAgent ? 'Create Super Agent' : 'Create Brand',
                auth: true,
                entityTypeRoute: EntityTypes.Brand,
                claimsRequired: this.userClaimsService.hasPermission(LotteryPlatformClaims.ViewBrands) ?
                    [LotteryPlatformClaims.ViewBrands] : [LotteryPlatformClaims.EditBrands],
                editEntityUri: 'Brands',
            },
            {
                nav: true,
                route: ['operators'],
                auth: true,
                settings: {
                    title: this.tokenClient.user.enableAgent ? 'Top Level Agents' : 'Operators',
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListOperators),
                    groupName: brandsGroupName
                },
                title: this.tokenClient.user.enableAgent ? 'List Top Level Agents' : 'List Operators',
                hasNavbar: false,
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                entity: 'Operators',
                editRoute: RouterConstants.RouteNames.ManageOperator,
                createNewRoute: RouterConstants.RouteNames.CreateOperator,
                claimsToAdd: [LotteryPlatformClaims.CreateOperator],
                claimsRequired: [LotteryPlatformClaims.ListOperators],
                name: RouterConstants.RouteNames.ListOperators,
                onColumnPushed: this.enableAgentColumnNameReplacement.bind(this)
            }, {
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.CreateOperator),
                    groupName: brandsGroupName
                },
                route: ['create-operator'],
                name: RouterConstants.RouteNames.CreateOperator,
                moduleId: PLATFORM.moduleName('./operator/operator'),
                title: this.tokenClient.user.enableAgent ? 'Create Top Level Agents' : 'Create Operator',
                auth: true,
                claimsRequired: [LotteryPlatformClaims.CreateOperator]
            },
            {
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.CreateOperator),
                    groupName: brandsGroupName
                },
                route: ['clone-operator'],
                name: RouterConstants.RouteNames.CloneOperator,
                moduleId: PLATFORM.moduleName('./operator/clone-operator'),
                title: 'Clone Operator & Brand',
                auth: true,
                claimsRequired: [LotteryPlatformClaims.CreateOperator]
            },
            {
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListOperators),
                    groupName: brandsGroupName
                },
                route: ['operator/:id'],
                isVisible: false,
                name: RouterConstants.RouteNames.ManageOperator,
                moduleId: PLATFORM.moduleName('./operator/operator'),
                title: 'Edit Operator',
                auth: true,
                entityTypeRoute: EntityTypes.Operator,
                claimsRequired: [LotteryPlatformClaims.EditOperators]
            },
            {
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListWinningClaims),
                    groupName: winningGroupName
                },
                route: ['winning-claim/:id'],
                isVisible: false,
                name: RouterConstants.RouteNames.ManageWinningNominationClaim,
                moduleId: PLATFORM.moduleName('./winning-nomination-claim/winning-nomination-claim'),
                title: 'Edit Winning Claim',
                auth: true,
                entityTypeRoute: EntityTypes.WinningNominationClaim,
                claimsRequired: [LotteryPlatformClaims.ListWinningClaims]
            },
            {
                route: ['winning-claims'],
                name: RouterConstants.RouteNames.ListWinningNominationClaims,
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                nav: true,
                auth: true,
                claimsRequired: [LotteryPlatformClaims.ManageWinningClaim],
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ManageWinningClaim),
                    groupName: winningGroupName
                },
                title: 'Winning Claim',
                entity: 'WinningNominationClaims',
                onRowSelected: function (x) {
                    _this.router.navigateToRoute(RouterConstants.RouteNames.ManageWinningNominationClaim, { id: x.id });
                },
                onColumnPushed: this.winningClaimHighlight.bind(this),
            },
            {
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListWinningClaims),
                    groupName: winningGroupName
                },
                route: ['instant-game-winning-claim/:id'],
                isVisible: false,
                name: RouterConstants.RouteNames.ManageInstantGameWinningClaim,
                moduleId: PLATFORM.moduleName('./instant-game-winning-claim/instant-game-winning-claim'),
                title: 'Edit Instant Game Winning Claim',
                auth: true,
                entityTypeRoute: EntityTypes.InstantGamesWinningClaim,
                claimsRequired: [LotteryPlatformClaims.ListWinningClaims]
            },
            {
                route: ['instant-game-winning-claims'],
                name: RouterConstants.RouteNames.ListInstantGamesWinningClaims,
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                nav: true,
                auth: true,
                claimsRequired: [LotteryPlatformClaims.ManageWinningClaim],
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ManageWinningClaim),
                    groupName: winningGroupName
                },
                title: 'Instant Game Winning Claims',
                entity: 'InstantGamesWinningClaims',
                onRowSelected: function (x) {
                    _this.router.navigateToRoute(RouterConstants.RouteNames.ManageInstantGameWinningClaim, { id: x.id });
                },
                onColumnPushed: this.winningClaimHighlight.bind(this),
            },
            {
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListWinningClaims),
                    groupName: winningGroupName
                },
                route: ['sweepstake-winning-claim/:id'],
                isVisible: false,
                name: RouterConstants.RouteNames.ManageSweepstakeWinningClaim,
                moduleId: PLATFORM.moduleName('./sweepstake-winning-claim/sweepstake-winning-claim'),
                title: 'Edit Sweepstake Winning Claim',
                auth: true,
                entityTypeRoute: EntityTypes.SweepstakeWinningClaim,
                claimsRequired: [LotteryPlatformClaims.ListWinningClaims]
            },
            {
                route: ['sweepstake-winning-claims'],
                name: RouterConstants.RouteNames.ManageSweepstakeWinningClaim,
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                nav: true,
                auth: true,
                claimsRequired: [LotteryPlatformClaims.ManageWinningClaim],
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ManageWinningClaim),
                    groupName: winningGroupName
                },
                title: 'Sweepstake Winning Claims',
                entity: 'SweepstakeWinningClaims',
                onRowSelected: function (x) {
                    _this.router.navigateToRoute(RouterConstants.RouteNames.ManageSweepstakeWinningClaim, { id: x.id });
                },
                onColumnPushed: this.winningClaimHighlight.bind(this),
            },
            {
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.CreateWinningClaims),
                    groupName: winningGroupName
                },
                route: ['create-winning-claim'],
                name: RouterConstants.RouteNames.CreateWinningNominationClaim,
                moduleId: PLATFORM.moduleName('./winning-nomination-claim/create-winning-nomination-claim'),
                title: 'Create Winning Claim',
                auth: true,
                entityTypeRoute: EntityTypes.WinningNominationClaim,
                claimsRequired: [LotteryPlatformClaims.CreateWinningClaims]
            },
            {
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.CreateWinningClaims)
                        && window['deployment'] !== 'Production',
                    groupName: winningGroupName
                },
                route: ['win-simulation'],
                name: RouterConstants.RouteNames.WinSimulation,
                moduleId: PLATFORM.moduleName('./winning-nomination-claim/win-simulation'),
                title: 'Win Simulation',
                auth: true,
                claimsRequired: [LotteryPlatformClaims.CreateWinningClaims]
            },
            // REPORTING
            {
                // just all Purchased transaction details (without individual ticket lines)
                route: ['transactions'],
                name: RouterConstants.RouteNames.ListTransactions,
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                nav: true,
                auth: true,
                claimsRequired: [LotteryPlatformClaims.ListTransactions],
                settings: {
                    title: 'All Purchased Transactions',
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListTransactions),
                    groupName: reportingGroupName
                },
                title: 'All Purchased Transactions',
                entity: 'Transactions',
                onRowSelected: function (x) {
                    if (x.transactionType == 3) { // sweepstake
                        _this.router.navigateToRoute(RouterConstants.RouteNames.ListSweepstakeTicketLines, { transactionId: x.id });
                        return;
                    }
                    _this.router.navigateToRoute(RouterConstants.RouteNames.ManageTransaction, { id: x.id });
                },
                onColumnPushed: this.enableAgentColumnNameReplacement.bind(this)
            },
            {
                // transaction with lottery ticket line draw details
                route: ['transaction-details'],
                name: RouterConstants.RouteNames.ListTransactionDetails,
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                nav: true,
                auth: true,
                claimsRequired: [LotteryPlatformClaims.ListTransactions],
                settings: {
                    title: 'Lottery Ticket Details',
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListTransactions),
                    groupName: reportingGroupName
                },
                title: 'Lottery Ticket Details',
                entity: 'TransactionTicketDetails',
                onRowSelected: function (x) {
                    _this.router.navigateToRoute(RouterConstants.RouteNames.ManageTicketDraw, { id: x.ticketDrawId });
                },
                onColumnPushed: this.enableAgentColumnNameReplacement.bind(this)
            },
            {
                // sweepstake purchased ticket list
                route: ['sweepstake-ticket-lines', 'sweepstake-ticket-lines-by-transaction/:transactionId'],
                name: RouterConstants.RouteNames.ListSweepstakeTicketLines,
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                nav: true,
                auth: true,
                claimsRequired: [LotteryPlatformClaims.ListTransactions],
                settings: {
                    title: 'Sweepstake Ticket Details',
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListTransactions),
                    groupName: reportingGroupName
                },
                title: 'Sweepstake Ticket Details',
                entity: 'SweepstakeTicketLines',
                fixedFilters: function (routeParams) {
                    if (!routeParams || !routeParams.transactionId)
                        return [];
                    var guid = Guid.generateGuid();
                    return [
                        QueryFilter.getQuery("transactionId", routeParams.transactionId, " contains(cast({0}, 'Edm.String'),'{1}') ", DataType.Default, true, true, guid, true, true)
                    ];
                },
                onRowSelected: function (x) {
                    //this.router.navigateToRoute(RouterConstants.RouteNames.ManageTicketDraw, { id: x.ticketDrawId });
                },
                onColumnPushed: this.enableAgentColumnNameReplacement.bind(this)
            },
            {
                settings: { showInMenu: false, groupName: reportingGroupName },
                route: ['transaction/:id'],
                name: RouterConstants.RouteNames.ManageTransaction,
                moduleId: PLATFORM.moduleName('./transaction/transaction'),
                title: 'View Transaction',
                auth: true,
                entityTypeRoute: EntityTypes.Transaction,
                claimsRequired: []
            },
            {
                route: ['players'],
                name: RouterConstants.RouteNames.ListPlayers,
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                nav: true,
                auth: true,
                claimsToAdd: [LotteryPlatformClaims.ViewPlayer],
                claimsRequired: [LotteryPlatformClaims.ListPlayers],
                settings: {
                    title: 'All Players',
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListPlayers),
                    groupName: reportingGroupName
                },
                title: 'All Players',
                entity: 'Players',
                onRowSelected: function (x) {
                    if (!_this.tokenClient.isBrandAdmin())
                        _this.router.navigateToRoute(RouterConstants.RouteNames.ManagePlayer, { id: x.id });
                },
                onColumnPushed: this.enableAgentColumnNameReplacement.bind(this)
            },
            {
                route: ['player/:id'],
                name: RouterConstants.RouteNames.ManagePlayer,
                moduleId: PLATFORM.moduleName('./player/player'),
                title: 'View Player',
                isVisible: false,
                auth: true,
                entityTypeRoute: EntityTypes.Player,
                claimsRequired: [],
                settings: { showInMenu: false, groupName: reportingGroupName },
                editEntityUri: 'Players',
            },
            //Ticket Lines
            {
                route: ['ticket-lines'],
                name: RouterConstants.RouteNames.ListTicketLines,
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                nav: true,
                auth: true,
                settings: {
                    title: 'All Ticket Sales',
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListTicketLines),
                    groupName: reportingGroupName
                },
                title: 'All Ticket Sales',
                entity: 'TicketLines',
                claimsRequired: [LotteryPlatformClaims.ListTicketLines],
                onColumnPushed: (function (c) {
                    if (c.name == "mainPicks" || c.name == "bonusPicks") {
                        c.valueConverter = function (x) { return x ? Enumerable.from(x.split(",")).orderBy(function (x) { return Number(x); }).toJoinedString(",") : ""; };
                    }
                    _this.enableAgentColumnNameReplacement(c);
                }).bind(this),
                onRowSelected: function (x) {
                    _this.router.navigateToRoute(RouterConstants.RouteNames.ManageTicketLine, { id: x.id });
                }
            },
            {
                route: ['ticket-lines/:id'],
                isVisible: false,
                name: RouterConstants.RouteNames.ManageTicketLine,
                moduleId: PLATFORM.moduleName('./ticket-lines/ticket-lines'),
                title: 'Manage Ticket Lines',
                editEntityUri: 'TicketLines',
                auth: true,
                claimsRequired: [LotteryPlatformClaims.ListTicketLines],
                settings: { showInMenu: false, groupName: reportingGroupName }
            },
            {
                route: ['ticket-line-draws'],
                name: RouterConstants.RouteNames.ListTicketLineDraws,
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                nav: true,
                auth: true,
                settings: {
                    title: 'All Ticket Draws',
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListTicketDraws),
                    groupName: reportingGroupName
                },
                title: 'All Ticket Draws',
                entity: 'TicketLineDraws',
                claimsRequired: [LotteryPlatformClaims.ListTicketDraws],
                onRowSelected: function (x) {
                    _this.router.navigateToRoute(RouterConstants.RouteNames.ManageTicketDraw, { id: x.id });
                },
                onColumnPushed: (function (c) {
                    if (c.name == "gamePlayerTicketDrawId") {
                        c.valueConverter = function (x) { return x > 0 ? x : null; };
                    }
                    _this.enableAgentColumnNameReplacement(c);
                }).bind(this),
            },
            {
                route: ['winning-tickets'],
                initialQueryId: 9000,
                name: RouterConstants.RouteNames.ListTicketLineDraws,
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                nav: true,
                auth: true,
                settings: {
                    title: 'Winning Tickets',
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListTicketDraws),
                    groupName: reportingGroupName
                },
                title: 'Winning Tickets',
                entity: 'TicketLineDraws',
                claimsRequired: [LotteryPlatformClaims.ListTicketDraws],
                onRowSelected: function (x) {
                    _this.router.navigateToRoute(RouterConstants.RouteNames.ManageTicketDraw, { id: x.id });
                },
                onColumnPushed: (function (c) {
                    if (c.name == "gamePlayerTicketDrawId") {
                        c.valueConverter = function (x) { return x > 0 ? x : null; };
                    }
                    _this.enableAgentColumnNameReplacement(c);
                }).bind(this),
            },
            {
                route: ['non-winning-tickets'],
                initialQueryId: 9001,
                name: RouterConstants.RouteNames.ListTicketLineDraws,
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                nav: true,
                auth: true,
                settings: {
                    title: 'Non Winning Tickets',
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListTicketDraws),
                    groupName: reportingGroupName
                },
                title: 'Non Winning Tickets',
                entity: 'TicketLineDraws',
                claimsRequired: [LotteryPlatformClaims.ListTicketDraws],
                onRowSelected: function (x) {
                    _this.router.navigateToRoute(RouterConstants.RouteNames.ManageTicketDraw, { id: x.id });
                },
                onColumnPushed: (function (c) {
                    if (c.name == "gamePlayerTicketDrawId") {
                        c.valueConverter = function (x) { return x > 0 ? x : null; };
                    }
                    _this.enableAgentColumnNameReplacement(c);
                }).bind(this),
            },
            {
                route: ['pending-tickets'],
                initialQueryId: 9002,
                name: RouterConstants.RouteNames.ListTicketLineDraws,
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                nav: true,
                auth: true,
                settings: {
                    title: 'Pending Tickets',
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListTicketDraws),
                    groupName: reportingGroupName
                },
                title: 'Pending Tickets',
                entity: 'TicketLineDraws',
                claimsRequired: [LotteryPlatformClaims.ListTicketDraws],
                onRowSelected: function (x) {
                    _this.router.navigateToRoute(RouterConstants.RouteNames.ManageTicketDraw, { id: x.id });
                },
                onColumnPushed: (function (c) {
                    if (c.name == "gamePlayerTicketDrawId") {
                        c.valueConverter = function (x) { return x > 0 ? x : null; };
                    }
                    _this.enableAgentColumnNameReplacement(c);
                }).bind(this),
            },
            {
                route: ['active-players'],
                initialQueryId: 9003,
                name: RouterConstants.RouteNames.ListPlayers,
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                nav: true,
                auth: true,
                claimsToAdd: [LotteryPlatformClaims.ViewPlayer],
                claimsRequired: [LotteryPlatformClaims.ListPlayers],
                settings: {
                    title: 'Active Players (Less than 30 days)',
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListPlayers),
                    groupName: reportingGroupName
                },
                title: 'Active Players (Less than 30 days)',
                entity: 'Players',
                onRowSelected: function (x) {
                    if (!_this.tokenClient.isBrandAdmin())
                        _this.router.navigateToRoute(RouterConstants.RouteNames.ManagePlayer, { id: x.id });
                },
                onColumnPushed: this.enableAgentColumnNameReplacement.bind(this)
            },
            {
                route: ['non-active-players'],
                initialQueryId: 9004,
                name: RouterConstants.RouteNames.ListPlayers,
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                nav: true,
                auth: true,
                claimsToAdd: [LotteryPlatformClaims.ViewPlayer],
                claimsRequired: [LotteryPlatformClaims.ListPlayers],
                settings: {
                    title: 'Non Active (More than 30 days)',
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListPlayers),
                    groupName: reportingGroupName
                },
                title: 'Non Active (More than 30 days)',
                entity: 'Players',
                onRowSelected: function (x) {
                    if (!_this.tokenClient.isBrandAdmin())
                        _this.router.navigateToRoute(RouterConstants.RouteNames.ManagePlayer, { id: x.id });
                },
                onColumnPushed: this.enableAgentColumnNameReplacement.bind(this)
            },
            {
                route: ['blocked-players'],
                initialQueryId: 9005,
                name: RouterConstants.RouteNames.ListPlayers,
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                nav: true,
                auth: true,
                claimsToAdd: [LotteryPlatformClaims.ViewPlayer],
                claimsRequired: [LotteryPlatformClaims.ListPlayers],
                settings: {
                    title: 'Blocked Payers',
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListPlayers),
                    groupName: reportingGroupName
                },
                title: 'Blocked Payers',
                entity: 'Players',
                onRowSelected: function (x) {
                    if (!_this.tokenClient.isBrandAdmin())
                        _this.router.navigateToRoute(RouterConstants.RouteNames.ManagePlayer, { id: x.id });
                },
                onColumnPushed: this.enableAgentColumnNameReplacement.bind(this)
            },
            {
                route: ['all-agents'],
                initialQueryId: 9006,
                name: RouterConstants.RouteNames.ListPlayers,
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                nav: true,
                auth: true,
                claimsToAdd: [LotteryPlatformClaims.ViewPlayer],
                claimsRequired: [LotteryPlatformClaims.ListPlayers],
                settings: {
                    title: 'All agents',
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ListPlayers),
                    groupName: reportingGroupName
                },
                title: 'All agents',
                entity: 'Players',
                onRowSelected: function (x) {
                    if (!_this.tokenClient.isBrandAdmin())
                        _this.router.navigateToRoute(RouterConstants.RouteNames.ManagePlayer, { id: x.id });
                },
                onColumnPushed: this.enableAgentColumnNameReplacement.bind(this)
            },
            {
                route: ['ticket-draws/:id'],
                isVisible: false,
                name: RouterConstants.RouteNames.ManageTicketDraw,
                moduleId: PLATFORM.moduleName('./ticket-draws/ticket-draws'),
                title: 'Manage Ticket Draws',
                editEntityUri: 'TicketLineDraws',
                auth: true,
                claimsRequired: [LotteryPlatformClaims.ListTicketDraws],
                settings: { showInMenu: false, groupName: reportingGroupName }
            },
            {
                route: ['global-billing'],
                name: GenesisRouterConstants.RouteNames.GlobalBilling,
                moduleId: PLATFORM.moduleName('./manage/global-billing'),
                nav: false,
                auth: true,
                claimsRequired: [LotteryPlatformClaims.ShowBilling],
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ShowBilling),
                    groupName: BillingGroupName
                },
                title: 'Billing'
            },
            // MANAGE
            {
                route: ['permissions/:type/:name/:id'],
                name: GenesisRouterConstants.RouteNames.ManagePermissions,
                moduleId: PLATFORM.moduleName('../../pages/admin/manage-organization/permissions'),
                nav: false,
                auth: true,
                claimsRequired: null,
                title: 'Manage Permissions'
            },
            {
                route: ['manage-validations/:type/:name/:id'],
                name: GenesisRouterConstants.RouteNames.ManageValidations,
                moduleId: PLATFORM.moduleName('../../pages/admin/manage-organization/validations/manage-validations'),
                nav: false,
                auth: true,
                claimsRequired: null,
                title: 'Manage Validations'
            },
            {
                name: GenesisRouterConstants.RouteNames.ManageUsers,
                moduleId: PLATFORM.moduleName('../../pages/admin/manage-organization/users'),
                route: ['users'],
                title: 'Manage Users',
                nav: true,
                auth: true,
                claimsRequired: [Claims.ManageUsers],
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(Claims.ManageUsers),
                    groupName: manageGroupName
                },
            },
            {
                name: GenesisRouterConstants.RouteNames.ManageBranches,
                moduleId: PLATFORM.moduleName('../../pages/admin/manage-organization/branches'),
                route: ['branches'],
                title: 'Manage Branches',
                nav: true,
                auth: true,
                claimsRequired: [Claims.ManageBranches],
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(Claims.ManageBranches),
                    groupName: manageGroupName
                },
            },
            {
                route: ['manage-lookups'],
                name: GenesisRouterConstants.RouteNames.ManageLookups,
                moduleId: PLATFORM.moduleName('../../pages/admin/manage-lookups/manage-lookups'),
                nav: true,
                auth: true,
                claimsRequired: [Claims.ManageLookups],
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(Claims.ManageLookups),
                    groupName: manageGroupName
                },
                title: 'Manage Lookups'
            },
            {
                route: ['manage-templates'],
                name: GenesisRouterConstants.RouteNames.ManageTemplates,
                moduleId: PLATFORM.moduleName('./manage-templates/manage-templates'),
                nav: true,
                auth: true,
                claimsRequired: [LotteryPlatformClaims.ManageTemplates],
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ManageTemplates),
                    groupName: manageGroupName
                },
                title: 'Manage Templates'
            },
            {
                route: ['manage-lottery-widgets'],
                name: GenesisRouterConstants.RouteNames.ManageLotteryWidgets,
                moduleId: PLATFORM.moduleName('./manage-lottery-widgets/manage-lottery-widgets'),
                nav: true,
                auth: true,
                claimsRequired: [LotteryPlatformClaims.ManageLotteryWidgets],
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ManageLotteryWidgets),
                    groupName: manageGroupName
                },
                title: 'Manage Lottery Widgets'
            },
            {
                route: ['manage-status-reason-transition'],
                name: GenesisRouterConstants.RouteNames.ManageStatusReasonTransition,
                moduleId: PLATFORM.moduleName('../../pages/admin/manage-status-reason-transitions/manage-status-reason-transitions'),
                nav: false,
                auth: true,
                claimsRequired: [LotteryPlatformClaims.ManageStatusReasonTransitions],
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ManageStatusReasonTransitions),
                    groupName: manageGroupName
                },
                title: 'Manage Status Reason Transitions'
            },
            {
                route: ['manage/dashboards'],
                name: 'manage dashboards',
                moduleId: PLATFORM.moduleName('../../pages/admin/manage-dashboards/manage-dashboards'),
                nav: true,
                auth: true,
                claimsRequired: [Claims.ManageDashboard],
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(Claims.ManageDashboard),
                    groupName: manageGroupName
                },
                title: 'Manage Dashboards'
            }, {
                route: ['manage/workflow'],
                name: 'manage workflow',
                moduleId: PLATFORM.moduleName('./workflow/workflow-configuration'),
                nav: true,
                auth: true,
                claimsRequired: [Claims.ManageWorkflow],
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(Claims.ManageWorkflow),
                    groupName: manageGroupName
                },
                title: 'Manage Workflow'
            },
            {
                route: ['api-settings'],
                name: RouterConstants.RouteNames.ListApiSettings,
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                nav: true,
                auth: true,
                claimsToAdd: [LotteryPlatformClaims.ManageApiSettings],
                claimsRequired: [LotteryPlatformClaims.ManageApiSettings],
                title: 'Api Settings',
                entity: 'ApiSettings',
                createNewRoute: RouterConstants.RouteNames.ManageApiSettings,
                onRowSelected: function (x) {
                    _this.router.navigateToRoute(RouterConstants.RouteNames.ManageApiSettings, { id: x.id });
                },
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ManageApiSettings),
                    groupName: manageGroupName
                },
            },
            {
                route: ['system-configuration'],
                name: GenesisRouterConstants.RouteNames.ManageSystemConfigurations,
                moduleId: PLATFORM.moduleName('../../pages/admin/manage-system-configuration/manage-system-configurations'),
                nav: true,
                auth: true,
                claimsRequired: [Claims.CanFlushCache],
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(Claims.CanFlushCache),
                    groupName: manageGroupName
                },
                title: 'System Configuations'
            },
            {
                route: ['manage-api-settings', 'manage-api-settings/:id'],
                name: RouterConstants.RouteNames.ManageApiSettings,
                moduleId: PLATFORM.moduleName('./manage-api-settings/manage-api-settings'),
                auth: true,
                claimsRequired: [LotteryPlatformClaims.ManageApiSettings],
                title: 'Manage Api Settings'
            },
            {
                route: ['manage/dashboards/user-dashboards'],
                claimsRequired: [Claims.ManageDashboard],
                moduleId: PLATFORM.moduleName('../../pages/admin/manage-dashboards/manage-user-dashboards'),
                name: GenesisRouterConstants.RouteNames.ManageUserDashboards,
                nav: false,
                auth: true,
                isVisible: false,
                title: 'Manage User Dashboards'
            },
            //support
            {
                route: ['support'],
                name: GenesisRouterConstants.RouteNames.SupportPage,
                moduleId: PLATFORM.moduleName('./manage/support'),
                nav: false,
                auth: true,
                claimsRequired: [LotteryPlatformClaims.ViewSupportPage],
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ViewSupportPage),
                    groupName: supportGroupName
                },
            },
            {
                route: ['support'],
                name: GenesisRouterConstants.RouteNames.SupportPage,
                moduleId: PLATFORM.moduleName('./manage/support'),
                nav: false,
                auth: true,
                claimsRequired: [LotteryPlatformClaims.ViewSupportPage],
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ViewSupportPage),
                    groupName: supportGroupName
                },
                title: 'Customer Service Portal'
            }, {
                moduleId: PLATFORM.moduleName("../../pages/authentication/change-password"),
                name: GenesisRouterConstants.RouteNames.ChangePassword,
                route: ["change-password"],
                title: this.i18N.tr("change-password-text"),
                auth: false
            },
            {
                moduleId: PLATFORM.moduleName("../../pages/authentication/reset-password"),
                name: GenesisRouterConstants.RouteNames.ResetPassword,
                route: ["ResetPassword"],
                title: this.i18N.tr("reset-password-text"),
                auth: false
            },
            {
                nav: true,
                route: ['affiliateLinkAnalytics'],
                auth: true,
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ViewAffiliateLinkAnalytics),
                    groupName: brandsGroupName
                },
                title: 'List Affiliate Link Analytics',
                moduleId: PLATFORM.moduleName('../../pages/queries/queries'),
                entity: 'AffiliateLinkAnalytics',
                name: RouterConstants.RouteNames.ListAffiliateLinkAnalytics
            },
            {
                route: ['topup'],
                name: RouterConstants.RouteNames.TopUp,
                moduleId: PLATFORM.moduleName('./manage/topup-page'),
                nav: true,
                auth: true,
                claimsRequired: [LotteryPlatformClaims.ViewTopUp],
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ViewTopUp),
                    groupName: brandsGroupName
                },
                title: 'Top-up'
            },
            {
                route: ['insurance-account'],
                name: RouterConstants.RouteNames.InsuranceAccount,
                moduleId: PLATFORM.moduleName('./manage/insurance-account-page'),
                nav: true,
                auth: true,
                claimsRequired: [LotteryPlatformClaims.ViewInsuranceAccount],
                settings: {
                    showInMenu: this.userClaimsService.hasPermission(LotteryPlatformClaims.ViewInsuranceAccount),
                    groupName: brandsGroupName
                },
                title: 'Insurance Account'
            },
        ];
    };
    Admin.prototype.winningClaimHighlight = function (c) {
        var _this = this;
        var func = function (x, item) {
            item.isSelected = item.currentActionTakerId ? item.currentActionTakerId == _this.tokenClient.user.userId :
                item.currentActionTakerDepartmentId == _this.tokenClient.user.departmentId;
            return x;
        };
        if (c.name == "currentActionTakerName" || c.name == "currentActionTakerDepartment") {
            c.valueConverter = func;
        }
    };
    Admin.prototype.processHtml = function (mainSlot, html, bindingContext) {
        var _this = this;
        //HtmlBehaviorResource
        var resource = metadata.get(metadata.resource, DataGrid);
        this.resources.registerElement('data-grid', resource);
        var div = document.createElement('div');
        if (!(mainSlot.children().length > 0)) {
            mainSlot.html('');
            mainSlot.append(div);
            $(div).html(html);
        }
        setTimeout(function () {
            var view = _this.templatingEngine.enhance({
                element: div, bindingContext: bindingContext, resources: _this.resources
            });
            view.attached();
        });
    };
    Admin.prototype.enableAgentColumnNameReplacement = function (c) {
        if (this.tokenClient) {
            UserModel.enableAgentColumnNameReplacement(this.tokenClient.user, c);
        }
    };
    Admin.prototype.logout = function () {
        var _this = this;
        this.tokenClient.logout().then(function (x) {
            location.reload();
        }, function (e) {
            _this.notificationClientService.show('Logout failed', '', NotificationType.Error);
        });
    };
    Admin.prototype.toMenuTab = function (x) {
        var route = x;
        route.isVisible = true;
        return {
            key: x.name,
            title: x.title,
            routes: [route]
        };
    };
    Admin.prototype.openSettingsDropdown = function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        this.settingsDropdownOpen = !this.settingsDropdownOpen;
    };
    Admin.prototype.attached = function () {
        _super.prototype.attached.call(this);
    };
    Admin.prototype.changePassword = function () {
        this.router.navigateToRoute(GenesisRouterConstants.RouteNames.ChangePassword);
    };
    Admin = __decorate([
        autoinject,
        __metadata("design:paramtypes", [Router, TokenClient, NotificationClientService,
            EntityTypeConfigurationHelper, LookupClientService,
            DialogClientService, EventAggregator, ViewResources,
            TemplatingEngine, SignalClientService, CacheClient,
            NavigationClientService, UserClaimsService, I18N, NotificationCenterEntryComposer])
    ], Admin);
    return Admin;
}(BaseApp));
export { Admin };
